import React from 'react';

import { QUERY_ROOT_ID, useCompleteFragment } from '@eluve/apollo-client';
import { Button, Stack } from '@eluve/components';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@eluve/components';

import { SiteBannerItem } from './SiteBannerItem';
import { siteBannersPublicDataFragment } from './operations';

type Props = {
  open: boolean;
  toggleOpen: () => void;
};

export const SystemStatusDialog: React.FC<Props> = ({ open, toggleOpen }) => {
  const data = useCompleteFragment({
    fragment: siteBannersPublicDataFragment,
    key: { id: QUERY_ROOT_ID },
    strict: false,
  });

  return (
    <Dialog open={open} onOpenChange={toggleOpen}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle className="font-normal tracking-normal text-text-secondary">
            System Status
          </DialogTitle>
        </DialogHeader>

        {data?.siteBanners.length ? (
          <Stack gap={2}>
            {data?.siteBanners.map((item) => (
              <SiteBannerItem
                key={`message-center-banner-item-${item.id}`}
                bannerType={item.bannerType}
                message={item.message}
                title={item.title}
              />
            ))}
          </Stack>
        ) : (
          <>There are no active system alerts or notifications at this time.</>
        )}

        <DialogFooter>
          <Button variant="secondary" onClick={toggleOpen}>
            Dismiss
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
